import type { ComponentType, SVGProps } from 'react';
import { CloseIcon } from './icons/CloseIcon';
import { EditIcon } from './icons/EditIcon';
import { ErrorIcon } from './icons/ErrorIcon';
import { EyeOnIcon } from './icons/EyeOnIcon';
import { EyeOffIcon } from './icons/EyeOffIcon';
import { HelpIcon } from './icons/HelpIcon';
import { InformationIcon } from './icons/InformationIcon';
import { LocationIcon } from './icons/LocationIcon';
import { SuccessIcon } from './icons/SuccessIcon';
import { WarningIcon } from './icons/WarningIcon';
import { CreditCardIcon } from './icons/CreditCardIcon';
import { SupportIcon } from './icons/SupportIcon';
import { ShieldIcon } from './icons/ShieldIcon';
import { CurrencyIcon } from './icons/CurrencyIcon';
import { UsersIcon } from './icons/UsersIcon';
import { BankIcon } from './icons/BankIcon';
import { MenuIcon } from './icons/MenuIcon';
import { TransactionOutIcon } from './icons/TransactionOutIcon';
import { TransactionInIcon } from './icons/TransactionInIcon';
import { ChevronDownIcon } from './icons/ChevronDownIcon';
import { ChevronLeftIcon } from './icons/ChevronLeftIcon';
import { ChevronRightIcon } from './icons/ChevronRightIcon';
import { CheckIcon } from './icons/CheckIcon';

export type IconName =
  | 'close'
  | 'edit'
  | 'error'
  | 'eye-on'
  | 'eye-off'
  | 'help'
  | 'information'
  | 'location'
  | 'success'
  | 'warning'
  | 'credit-card'
  | 'support'
  | 'shield'
  | 'currency'
  | 'users'
  | 'bank'
  | 'menu'
  | 'transaction-out'
  | 'transaction-in'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'check';

export const icons: Record<IconName, ComponentType<SVGProps<SVGSVGElement>>> = {
  close: CloseIcon,
  edit: EditIcon,
  error: ErrorIcon,
  'eye-on': EyeOnIcon,
  'eye-off': EyeOffIcon,
  help: HelpIcon,
  information: InformationIcon,
  location: LocationIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  'credit-card': CreditCardIcon,
  support: SupportIcon,
  shield: ShieldIcon,
  currency: CurrencyIcon,
  users: UsersIcon,
  bank: BankIcon,
  menu: MenuIcon,
  'transaction-out': TransactionOutIcon,
  'transaction-in': TransactionInIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  check: CheckIcon,
};
